import { ICharacter } from "@next-platform/client-common-core";
import React, { createContext, ReactNode, useContext } from "react";

import { FilterKeys } from "@/components/type";
import { useMyChatbotsData } from "@/hooks";

interface IMyChatbotsSearchContextValue {
  chatbots: ICharacter[] | null;
  filteredAndSortedChatbots: ICharacter[] | null;
  isLoading: boolean;
  isFiltering: boolean;
  isLoadingMoreGroupchats: boolean;
  shouldShowLoadMoreButton: boolean;
  error: Error | null;
  localSortType: string;
  localSearchQuery: string;
  localFilterBy: FilterKeys;
  localFilterValue: string;
  handleLocalSort: (sortType: string) => void;
  handleLocalSearch: (query: string) => void;
  handleLocalFilter: (filterKey: FilterKeys, filterValue: string) => void;
  refetch: () => Promise<void>;
  loadMoreChatbots: () => void;
}

const MyChatbotsSearchContext = createContext<IMyChatbotsSearchContextValue | undefined>(undefined);

interface IMyChatbotsSearchProviderProps {
  children: ReactNode;
  initialSortType?: string;
}

export const MyChatbotsSearchProvider = ({ children, initialSortType = "latest" }: IMyChatbotsSearchProviderProps) => {
  const myChatbotsData = useMyChatbotsData({ initialSortType });

  return <MyChatbotsSearchContext.Provider value={myChatbotsData}>{children}</MyChatbotsSearchContext.Provider>;
};

export const useMyChatbotsSearch = (): IMyChatbotsSearchContextValue => {
  const context = useContext(MyChatbotsSearchContext);
  if (context === undefined) {
    throw new Error("useMyChatbotsSearch must be used within a MyChatbotsSearchProvider");
  }
  return context;
};
